import { render, staticRenderFns } from "./EmailRecipientsGroups.vue?vue&type=template&id=62d96b44"
import script from "./EmailRecipientsGroups.vue?vue&type=script&lang=js"
export * from "./EmailRecipientsGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports